export default __webpack_public_path__ + "static/media/ethosEstatePlanning.e6428fc6.svg";